export default "__VITE_ASSET__DC3kLoae__"